import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import './GamesMenu.scss'

export const GamesMenu: React.FC = () => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement | null>(null)
  const navigate = useNavigate()

  const onToggleClick = useCallback(() => {
    setOpen((prev) => !prev)
  }, [])

  const go = useCallback(
    (path: '/pasihyppely' | '/sotilasarvot') => {
      setOpen(false)
      void navigate(path)
    },
    [navigate]
  )

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (!open) return
      const el = containerRef.current
      if (el && e.target instanceof Node && !el.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [open])

  return (
    <div className="gamesMenu" ref={containerRef}>
      <button
        type="button"
        className={`gamesToggle ${open ? 'open' : ''}`}
        onClick={onToggleClick}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="hamburger" aria-hidden>
          <span />
          <span />
          <span />
        </span>
        Inttipelit
      </button>
      {open && (
        <div className="dropdown" role="menu" aria-label="Games menu">
          <button type="button" className="menuItem" onClick={() => go('/pasihyppely')}>
            Pasihyppely
          </button>
          <button type="button" className="menuItem" onClick={() => go('/sotilasarvot')}>
            Sotilasarvot
          </button>
        </div>
      )}
    </div>
  )
}
